import React from 'react';
import styles from '../AboutPage.module.scss';

export const AboutPageLayout = ({ leftContent, rightContent, isMain }) => (
  <div className={styles.section}>
    <div className={`${styles.leftBlock} ${isMain ? styles.mainSection : ''}`}>{leftContent}</div>
    <div className={styles.rightBlock}>{rightContent}</div>
  </div>
);
